import React, {useState} from 'react';
import {loadStripe} from '@stripe/stripe-js';
import {CardElement, Elements, useElements, useStripe} from '@stripe/react-stripe-js';
import './style.css'
import firebase from 'gatsby-plugin-firebase'
const stripePromise = loadStripe("pk_test_51HOrHEIj9mPFNSOSEVWOXrhMUJcUnOeri4mwJDG8pXqZ8ypdbJwJ2455qcedXVY2rBKyeNhHZG0RzaIhZAxNcmbd00l9w576vJ");

const CARD_OPTIONS = {
  iconStyle: 'solid',
  style: {
    base: {
      iconColor: '#c4f0ff',
      color: '#fff',
      fontWeight: 500,
      fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {
        color: '#fce883',
      },
      '::placeholder': {
        color: '#87bbfd',
      },
    },
    invalid: {
      iconColor: '#ffc7ee',
      color: '#ffc7ee',
    },
  },
};

const CardField = ({onChange}) => (
  <div className="FormRow">
    <CardElement options={CARD_OPTIONS} onChange={onChange} />
  </div>
);

const SubmitButton = ({processing, error, children, disabled}) => (
  <button
    className={`SubmitButton ${error ? 'SubmitButton--error' : ''}`}
    type="submit"
    disabled={processing || disabled}
  >
    {processing ? 'Processing...' : children}
  </button>
);

const ErrorMessage = ({children}) => (
  <div className="ErrorMessage" role="alert">
    <svg width="16" height="16" viewBox="0 0 17 17">
      <path
        fill="#FFF"
        d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
      />
      <path
        fill="#6772e5"
        d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
      />
    </svg>
    {children}
  </div>
);


const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [cardComplete, setCardComplete] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const data = JSON.parse(localStorage.getItem("AppUser"))
  const [billingDetails, setBillingDetails] = useState({
    email: data.email,
    name: data.displayName,
  });

const saveSettings = () => {
  let settings = {}
  const showArrows = JSON.parse(localStorage.getItem("showArrows"))
  const weatherDetails = JSON.parse(localStorage.getItem("weatherDetails"))
  const weatherAppLocations = JSON.parse(localStorage.getItem("weatherAppLocations"))
  const theme = JSON.parse(localStorage.getItem("theme"))

  if(showArrows)
  settings.showArrows = showArrows
  if(weatherDetails)
  settings.weatherDetails = weatherDetails
  if(theme)
  settings.theme = theme

  const user = firebase.auth().currentUser
  firebase.firestore().collection('users').doc(user.uid)
  .update({
    settings,
    cities : weatherAppLocations
  }).then(() => {
    window.location.reload()
  })
  .catch(err => alert(err))


}

const activateMembership = token => { 
    fetch(`https://us-central1-weatherapp-3646a.cloudfunctions.net/UpgradeUser?paymentId=${token}&user=${data.uid}`)
        .then(response => response.json())
        .then(result => {
            if(result.success) {
              const data = JSON.parse(localStorage.getItem("AppUser"))
              data.isActive = true
              localStorage.setItem("AppUser" , JSON.stringify(data))
              saveSettings()
              // window.location.reload();
            }else {
              alert("Subscription Activation has been failed, No Amount is charged")
            }
        })
        .catch(error =>{ window.alert("Something went wrong")})  
}
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    if (error) {
      elements.getElement('card').focus();
      return;
    }

    if (cardComplete) {
      setProcessing(true);
    }

    const payload = await stripe.createPaymentMethod({
      type: 'card',
      card: elements.getElement(CardElement),
      billing_details: billingDetails,
    });

    setProcessing(false);

    if (payload.error) {
      setError(payload.error);
    } else {
      setPaymentMethod(payload.paymentMethod);
      activateMembership(payload.paymentMethod.id)
    }
  };

  return paymentMethod ? (
    <div className="Result">
      <div className="ResultTitle" role="alert">
        Payment successful
      </div>
      <div className="ResultMessage">
        Successfully Subscribed to Weather Pro, Activating Membership Please wait...
      </div>
      {/* <ResetButton onClick={reset} /> */}
    </div>
  ) : (
    <form className="Form" onSubmit={handleSubmit}>
      <fieldset className="FormGroup">
        <CardField
          onChange={(e) => {
            setError(e.error);
            setCardComplete(e.complete);
          }}
        />
      </fieldset>
      {error && <ErrorMessage>{error.message}</ErrorMessage>}
      <SubmitButton processing={processing} error={error} disabled={!stripe}>
        Pay $2.99
      </SubmitButton>
    </form>
  );
};

const ELEMENTS_OPTIONS = {
  fonts: [
    {
      cssSrc: 'https://fonts.googleapis.com/css?family=Roboto',
    },
  ],
};


const Stripe = () => {
  return (
    <div className="AppWrapper">
      {/* className="AppWrapper" 
      style={{
      margin : '5% 20%'
    }}
      */}
      <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
        <CheckoutForm />
      </Elements>
    </div>
  );
};

export default Stripe;